<script lang="ts">
  export let size: any = 24;
</script>

<svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.83994 2.73331L3.36661 8.52665C3.15994 8.74665 2.95994 9.17998 2.91994 9.47998L2.67328 11.64C2.58661 12.42 3.14661 12.9533 3.91994 12.82L6.06661 12.4533C6.36661 12.4 6.78661 12.18 6.99327 11.9533L12.4666 6.15998C13.4133 5.15998 13.8399 4.01998 12.3666 2.62665C10.8999 1.24665 9.78661 1.73331 8.83994 2.73331Z"
    stroke="#47675B"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M7.92664 3.69995C8.2133 5.53995 9.70664 6.94662 11.56 7.13328"
    stroke="#47675B"
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
